export default __webpack_public_path__ + "static/media/notification.d28da48d.png";